import React, {useMemo, useEffect} from 'react';
import moment from 'moment';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Table} from 'semantic-ui-react';
import {Filter, DefaultColumnFilter} from '../common/TableFilters';
import {shortDate} from '../../../common/constants/datesFormat';
import ProgressBar from '../../../common/components/progressBar';
import PartsOrdersIcon from '../common/icons/PartsOrdersIcon';
import CampaignViewIcon from '../common/icons/CampaignViewIcon';
import TablePaginator from '../common/TablePaginator';

const columnsTableWithProps = (isUserTde) => {
  return [
    {
      'Header': 'NÚMERO CAMPAÑA',
      'accessor': 'campaingNo',
    },
    {
      'Header': 'CÓDIGO SCC',
      'accessor': 'sscCode',
    },
    {
      'Header': 'NOMBRE CAMPAÑA',
      'accessor': 'campaingName',
    },
    {
      'Header': 'USUARIO',
      'accessor': 'user',
    },
    {
      'Header': 'FECHA CREACIÓN',
      'accessor': 'createDate',
      'Cell': ({row}) => {
        const createDate = row.original && row.original.createDate;
        return moment(createDate).format(shortDate);
      },
    },
    {
      'Header': 'ESTADO',
      'accessor': 'status',
      'Cell': ({row}) => {
        const status = row.original && row.original.status;
        return status === 'A' ? 'ACTIVO' : 'INACTIVO';
      },
    },
    {
      'Header': 'PROGRESO',
      'accessor': 'totalWarranties',
      'width': 200,
      'disableFilters': true,
      'Cell': ({row}) => {
        const {totalWarranties, totalChassis} = row.original;
        return (
          <ProgressBar
            key={row.id}
            label='TWC'
            partialQuantity={totalWarranties}
            totalQuantity={totalChassis}
            mediumPercent={79}
            lowPercent={35}
          />
        );
      },
    },
    {
      'id': 'actions',
      'Header': 'ACCIONES',
      'disableFilters': true,
      'Cell': ({row}) => {
        const {campaingNo, status} = row.original;
        return (
          <>
            <CampaignViewIcon
              campaingNo={campaingNo}
              isUserTde={isUserTde}
            />
            <PartsOrdersIcon
              campaingNo={campaingNo}
              isUserTde={isUserTde}
              inactiveCampaign={status !== 'A'}
            />
          </>
        );
      },
    },
  ];
};


const CampaignTable = ({dataTable, handleChange, isUserTde, countRows}) => {
  const columnsTable = columnsTableWithProps(isUserTde);
  const data = useMemo(() => dataTable, []);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    rows,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    useFilters,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    if (rows.length !== countRows) {
      handleChange('countRows', rows.length);
    }
  }, [rows]);

  return (
    <>
      <div className='table-container'>
        <Table
          className='interactive'
          compact
          striped
          {...getTableProps()}
        >
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign='center'
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key='filters' id='filters'>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`filter-${index}`}
                    textAlign='center'
                  >
                    <Filter column={column} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign='center'>
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell textAlign='center'>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePaginator
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default CampaignTable;
